import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import {
    CUSTOM_PRICING,
    FINE_PRINT_WITH_FIXED_FEE,
    FINE_PRINT_WITHOUT_FIXED_FEE,
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
    PER_PAID_TICKET_TEXT,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES,
    PACKAGE_THREE_FEATURES,
    PACKAGE_TWO_FEATURES,
} from '../../constants/features';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

import AssortmentsEssentialsSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsEssentialsSimpleIllustration';
import AssortmentsProfessionalSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsProfessionalSimpleIllustration';
import AssortmentsPremiumSimpleIllustrationSvg from 'eventbrite_design_system/iconography/icons/AssortmentsPremiumSimpleIllustration';

export default {
    packagesList: {
        heading: lazyGettext('Select a package to create your next event'),
        secondaryHeading: lazyGettext(
            "Your existing events won't be impacted, and you can change your package at any time.",
        ),
        packages: {
            [PACKAGE_ONE]: {
                name: PACKAGE_ONE_NAME,
                illustration: <AssortmentsEssentialsSimpleIllustrationSvg />,
                description: lazyGettext(
                    'The essentials you need to start selling tickets in minutes',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                copyPrimaryCTA: lazyGettext('Create New Event'),
                features: PACKAGE_ONE_FEATURES,
                secondaryCTA: lazyGettext('Learn more about Essentials'),
                isProminentPackage: false,
                logoBgColor: 'grey-900',
                logoImg: 'pricing/logo-essentials',
                logoWidth: 142,
                logoHeight: 35,
            },
            [PACKAGE_TWO]: {
                name: PACKAGE_TWO_NAME,
                illustration: <AssortmentsProfessionalSimpleIllustrationSvg />,
                description: lazyGettext(
                    'A powerful solution to boost sales and grow your business',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                copyPrimaryCTA: lazyGettext('Continue Copying'),
                includeOtherFeatures: true,
                features: PACKAGE_TWO_FEATURES,
                secondaryCTA: lazyGettext('Learn more about Professional'),
                isProminentPackage: true,
                logoBgColor: 'ui-orange',
                logoImg: 'pricing/logo-professional',
                logoWidth: 257,
                logoHeight: 30,
            },
            [PACKAGE_THREE]: {
                name: PACKAGE_THREE_NAME,
                illustration: <AssortmentsPremiumSimpleIllustrationSvg />,
                description: lazyGettext(
                    'Tailored partnership for organizers with large and complex events',
                ),
                priceDescription: CUSTOM_PRICING,
                includeOtherFeatures: true,
                features: PACKAGE_THREE_FEATURES,
                secondaryCTA: lazyGettext('Learn more about Premium'),
                isProminentPackage: false,
                logoBgColor: 'white',
                logoImg: 'pricing/logo-premium',
                logoWidth: 155,
                logoHeight: 61,
            },
        },
        CTAs: [
            lazyGettext('Get Started Free'),
            lazyGettext('Get Started Free'),
            lazyGettext('Contact us'),
        ],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        finePrint: lazyGettext(
            '* Payment processing and taxes will apply to all packages',
        ),
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        finePrintWithFixedFee: FINE_PRINT_WITH_FIXED_FEE,
        finePrintWithoutFixedFee: FINE_PRINT_WITHOUT_FIXED_FEE,
    },
};
